import React from 'react';
import ReactDOM from 'react-dom/client';
import CentillionAmbient2038 from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CentillionAmbient2038 />
  </React.StrictMode>
);
